import { combineReducers } from "redux";

import data from "./data.js";

export default combineReducers({
  data,
});
